<template>
    <div class="guide_content">
        <div class="right-div">
            <img src="https://prodcdn.shaklee.com.cn/shaklee/upload/arrow_1_1.png" alt="shaklee" style="width: 132px;height: 76px;">
        </div>
        <div class="left-div">
            <img src="https://prodcdn.shaklee.com.cn/shaklee/upload/step1_title_2.png" alt="shaklee" style="width: 177px;height: 44px;">
        </div>
        <div class="clear"></div>
        <div class="img_step2_title">
            <img src="https://prodcdn.shaklee.com.cn/shaklee/upload/step2_title_2.png" alt="shaklee" style="width: 258px;height: 44px;">
        </div>
        <div class="img_step2">
            <img src="https://prodcdn.shaklee.com.cn/shaklee/upload/step2_content_2.png" alt="shaklee" style="width: 102px;height: 110px;">
        </div>
        <div class="img_title3">
            <!-- <img src="https://prodcdn.shaklee.com.cn/shaklee/upload/step3_title_2.png" alt="shaklee" style="width: 313px;height: 80px;"> -->
            <img src="../assets/step3_title_2_2.png" alt="shaklee" style="width: 313px;height: 80px;">
        </div>
        <div class="img_phone">
            <img src="../assets/step3_phone_2_1.png" alt="shaklee" >
        </div>
    </div>
</template>

<script>
export default {
    created() {
        const userAgent = navigator.userAgent.toLowerCase();
        const isWeChatBrowser = userAgent.includes('micromessenger');
        if (!isWeChatBrowser) {
            console.log("不是微信环境，跳转到登录");
            this.$router.push('/');
            // this.loginFishedTitle = "微信环境不支持该功能, 请在浏览器中打开";
        } else {
            //微信内跳转到该页面获取openid
            var guiderUrl = "https://eshop-s.shaklee.com.cn/shaklee-staticpage/html/eshop-guider.html";
            window.location.href = guiderUrl;
        }
    },
}
</script>

<style scoped>
.guide_content {
    background: #353536;
    margin-top: 0px;
    text-align: center;
    height: 101%;
    /* padding-left: 20px; */
}

.clear {
    clear: right;
}

.left-div {
    float: right;
    margin-top: 55px;
    margin-right: 10px;
}

.right-div {
    float: right;
    margin-top: 5px;
    margin-right: 15px;
}

.img_title3 {
    margin-top: 20px;
    padding-bottom: 0px;
}

.img_step2_title {
    margin-top: 30px;
}

.img_step2 {
    text-align: center;
}

.img_phone {
    margin-top: -15px;
}

img {
    max-width: 110%;
    /* 图片最大宽度为其容器的100% */
    height: auto;
    /* 图片高度自适应，保持宽高比 */
    max-height: 90%;
}
</style>


// WEBPACK FOOTER //
// src/page/Guide.vue